import { Components, Theme } from '@mui/material/styles';

export const MuiPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--palette-background-paper)',
      border: '1px solid var(--palette-divider)',
    },
  },
};
